import { get } from "lodash";
import { ChevronRight, FileText, Hash, KeyRound } from "lucide-react";
import { useEffect } from "react";

import StepBody from "../components/StepBody";
import StepHeading from "../components/StepHeading";
import CarrierMark from "../components/CarrierMark";
const SelectVerificationMethod = ({
  step,
  nextStep,
  loginInformation,
  posthog,
  session,
  setIntegration,
}) => {
  const isManualEnabled = get(session, "config.manual.enabled");
  const isEnhancedEnabled = get(session, "config.manual.enhanced");

  const carrierIntegrations = get(loginInformation, "carrier.integrations", []);

  const isPolicyLookupEnabled = carrierIntegrations.some(
    (integration) => integration.type === "L123",
  );
  useEffect(() => {
    posthog.capture("$pageview", {
      step,
      carrier: get(loginInformation, "carrier.id"),
    });
  }, [posthog]);
  return (
    <>
      <StepBody>
        <CarrierMark loginInformation={loginInformation} />
        <StepHeading
          title="Share your insurance information"
          description="Choose how you’d like to share your insurance information."
        />
        <div className="grid auto-rows-fr gap-3">
          {carrierIntegrations.map((carrierIntegration) => (
            <MethodOption
              icon={carrierIntegration.type === "L123" ? Hash : KeyRound}
              title={getTextForIntegrationSelection(carrierIntegration)}
              onClick={() => {
                setIntegration(carrierIntegration.integration);
                nextStep(getNextStep(carrierIntegration));
              }}
            />
          ))}

          {isManualEnabled && isEnhancedEnabled && isPolicyLookupEnabled && (
            <MethodOption
              icon={FileText}
              title={"Search using document"}
              onClick={() => nextStep("enhanced-manual-policy-document")}
            />
          )}
        </div>
      </StepBody>
    </>
  );
};

const MethodOption = ({ icon: Icon, title, onClick }) => (
  <button
    onClick={onClick}
    className="flex h-full min-h-24 w-full items-center gap-4 rounded-lg border border-border bg-surface px-4 py-4 text-left text-ink transition-colors hover:border-ink-secondary hover:bg-surface-muted active:bg-surface-pressed"
  >
    <span className="flex size-11 shrink-0 items-center justify-center rounded-full bg-surface-muted">
      <Icon aria-hidden className="size-5" strokeWidth={1.75} />
    </span>
    <span className="min-w-0 flex-1 text-body-lg font-medium  text-pretty">
      {title}
    </span>
    <ChevronRight aria-hidden className="size-5 shrink-0 text-ink-secondary" strokeWidth={1.75} />
  </button>
);

// This function constructs the text for the each integration selection button
const getTextForIntegrationSelection = (carrierIntegration) => {
  // If the integration has a displayName defined, override the button text
  if (get(carrierIntegration, "displayName")) {
    return "Log in to " + get(carrierIntegration, "displayName");
  }
  return get(carrierIntegration, "buttonText");
};

const getNextStep = (carrierIntegration) => {
  switch (carrierIntegration.type) {
    case "L123":
      return "policy-lookup";
    case "vnc-session":
      return "vnc-session";
    case "user-portal":
    default:
      return "login";
  }
};
export default SelectVerificationMethod;
